import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {NON_DOCUMENTED_CONTEXTS} from '../documents/DocumentNode';
import {AppConfig} from '../../config/AppConfig';

export interface GetRegisteredNodesOptions {
	nodeContexts: NodeContext[];
	nodeTypesByContext: Record<NodeContext, string[]>;
}

export type NodesByContextRecord = Record<NodeContext, string[]>;
export function createNodesByContextRecord(): NodesByContextRecord {
	const nodeTypesByContext: NodesByContextRecord = {
		[NodeContext.ANIM]: [],
		[NodeContext.AUDIO]: [],
		[NodeContext.COP]: [],
		[NodeContext.EVENT]: [],
		[NodeContext.GL]: [],
		[NodeContext.JS]: [],
		[NodeContext.MANAGER]: [],
		[NodeContext.MAT]: [],
		[NodeContext.OBJ]: [],
		[NodeContext.POST]: [],
		[NodeContext.ROP]: [],
		[NodeContext.SOP]: [],
	};
	return nodeTypesByContext;
}

export async function getRegisteredNodes(options: GetRegisteredNodesOptions) {
	await AppConfig.register({sceneName: null});
	const {nodeTypesByContext, nodeContexts} = options;
	const nodeContextsSet: Set<NodeContext> = new Set();
	Poly.nodesRegister.map().forEach((contextMap, context) => {
		nodeContextsSet.add(context);
		nodeTypesByContext[context] = [];
		contextMap.forEach((nodeClass, nodeType) => {
			nodeTypesByContext[context].push(nodeType);
		});
	});
	nodeContexts.splice(0, nodeContexts.length);
	nodeContextsSet.forEach((context) => nodeContexts.push(context));
}
export function removeNonDocumentedNodeContexts(list: NodeContext[]) {
	return list.filter((nodeContext) => !NON_DOCUMENTED_CONTEXTS.has(nodeContext));
}
